import React, { useEffect, useState } from 'react';
import { ActivityIndicator, FlatList, ScrollView, View } from "react-native"
import { useDispatch, useSelector } from 'react-redux';
import Colors from "../../constants/Colorsv2"
import { Text } from '../../globalComponents/NativeOverrides';
import { analytics_getLeadersByPlayerId, analytics_pinLeader } from '../../store/actionsv1/analytics';
import { CategoryProps, LeaderProps, TimerangeProps } from '../../store/types/analytics_svc';
import PlayerLeaderCard from '../Discover/components/PlayerLeaderCard';



const PlayerLeadersScreen = ({ route, navigation }:any) => {
    const [ loading, setLoading ] = useState(false);
    const dispatch = useDispatch();

    const app_size:{ width:number } = useSelector((state:any) => state.util.app_size, (left, right) => left.width == right.width)
    
    const active_player_leaders:LeaderProps[] = useSelector((state:any) => state.analytics.leaders.filter((l:LeaderProps) => l.player_id == route.params.player_id && l.active), (left, right) => {
        if(left.length != right.length){ return false }
        let left_pinned = left.filter(l => l.pinned).length
        let right_pinned = right.filter(l => l.pinned).length
        if(left_pinned != right_pinned){ return false }
        return true
    })
    const categories:CategoryProps[] = useSelector((state:any) => state.analytics.stored_categories, (left, right) => left.length == right.length)
    const time_ranges:TimerangeProps[] = useSelector((state:any) => state.analytics.stored_timeranges, (left, right) => left.length == right.length)

    useEffect(() => {
        if(!route.params.player_id){ return }
        getPlayerLeadersFromServer(route.params.player_id)
    },[route.params.player_id])

    const getPlayerLeadersFromServer = async(player_id:string) => {
        setLoading(true)
        await dispatch(analytics_getLeadersByPlayerId(player_id))
        setLoading(false)
    }

    const renderLeaders = (data:{ item:LeaderProps, index:number }) => {
        const category = categories.find(c => c.category_id == data.item.category_id)
        const time_range = time_ranges.find(t => t.timerange_id == data.item.timerange_id)
        if(!category || !time_range){ return <></> }
        return (
            <PlayerLeaderCard 
                view_mode='edit' 
                width={(app_size.width / 2) - 20} 
                category={category} 
                time_range={time_range} 
                leader={data.item} 
                onSelect={(leader) => navigation.navigate('DiscoverStack', { screen: 'Leaderboard', initial:false, params: { category_id: leader.category_id, timerange_id:leader.timerange_id } })}
                onPin={(leader) => dispatch(analytics_pinLeader(leader.leader_id))}
                />
        )
    }

    return (
        <View style={{ flex:1, backgroundColor:Colors.shades.white }}>
            <ScrollView style={{ flex: 1 }}>
                <View style={{ padding:20 }}>
                    <Text size={18} color={Colors.brand.midnight} weight='bold' textAlign='center'>My Leader Cards</Text>
                </View>
                <View style={{ justifyContent:'center', alignItems:'center' }}>
                    <FlatList numColumns={2} data={active_player_leaders.sort((a,b) => a.leader_id - b.leader_id)} renderItem={renderLeaders} keyExtractor={(item) => item.leader_id.toString()}/>
                </View>
                {loading?
                <View style={{ justifyContent:'center', alignItems:'center', padding:20 }}>
                    <ActivityIndicator size='large' color={Colors.brand.midnight}/>
                </View>
                :<></>}
            </ScrollView>
        </View>
    )
}

export default PlayerLeadersScreen